<template>
  <div class="about">
    <h1>{{message}}</h1>
  </div>
</template>


<script>
// @ is an alias to /src

export default {
  data () {
    return {
      message: 'Now Redirecting',
      redirectList: [
        {
          from: 'RyujoHadanoV1',
          to: 'JRv4XwutcXOtawtc0ORY'
        }
      ]
    }
  },
  created () {
    var botEditor = 'https://bot-editor-prod.firebaseapp.com/'

    var target = this.redirectList.filter(e => {
      return this.$route.params.id === e.from
    })[0]
    
    if (target) {
      location.href = `${botEditor}${target.to}`
    } else {
      this.message = 'チャットが見つかりませんでした。'
    }


  }
}
</script>
